/**
 * Forms
 */

(function($) {


  // Paikkakunnat multiselecttree logic

  jQuery(document).on('gform_post_render', function(){

    var $container = $('#paikkakunnat_input');
    var $shadow_input = $('#input_3_20, #input_24_20, #input_18_20, #input_43_20');
    if($container.length && $shadow_input.length && !$container.hasClass('js-inited')) {

      $container.addClass('js-inited');

      var $select = $('#selectCity');
      var $value = $('#paikkakunnat_count').find('.value');

      var saved_value = $shadow_input.val();

      // Hook to <select> changes
      $select.on('change', function() {

        // Put all selected values into array
        var values = [];
        $(this).find(':selected').each(function(i, selected){
          values[i] = $(selected).text();
        });

        if (values.length > 0) {
          //var str = values.replace(/ /g,'');
          var str = values.join(',');

          // put value into shadow input
          $shadow_input.val(str);

          // make sure the value made it to the input
          var shadow_str = $shadow_input.val();
          //console.log(shadow_str);
          var shadow_arr = shadow_str.split(',');
          //console.log(shadow_arr);
          $value.text(shadow_arr.length + ' kpl');

        } else {
          $shadow_input.val('');
          $value.text('0');
        }

      });

      // After reload, validation error, going to previous page => value saved, UI not
      if(saved_value.length) {
        saved_value = saved_value.replace(/ /g,'');
        var saved_arr = saved_value.split(',');
        var $options = $select.find('option');
        $.each( saved_arr, function( key, value ) {
          $options.filter(function(index) {
            if($(this).text() === value) {
              // Manipulate treeMultiselect "shadow" <select> to change the UI
              var option_index = key + 1;
              $(this).attr('data-index', option_index);
              $(this).attr('selected', 'selected');
            }
          });

        });


      } // end saved_value.length

      // Init Multiselect

      var args_multiselect = {

        // Sections have checkboxes which when checked, check everything within them
        allowBatchSelection: true,

        // Selected options can be sorted by dragging
        // Requires jQuery UI
        sortable: false,

        // Adds collapsibility to sections
        collapsible: true,

        // Enables selection of all or no options
        enableSelectAll: false,

        // Only used if enableSelectAll is active
        selectAllText: 'Valitse kaikki',

        // Only used if enableSelectAll is active
        unselectAllText: 'Poista kaikki valinnat',

        // Disables selection/deselection of options; aka display-only
        freeze: false,

        // Hide the right panel showing all the selected items
        hideSidePanel: false,

        // Only sections can be checked, not individual items
        onlyBatchSelection: false,

        // Separator between sections in the select option data-section attribute
        sectionDelimiter: '/',

        // Show section name on the selected items
        showSectionOnSelected: false,

        // Activated only if collapsible is true; sections are collapsed initially
        startCollapsed: false,

        // Allows searching of options
        searchable: true,

        // Set items to be searched. Array must contain 'value', 'text', or 'description', and/or 'section'
        searchParams: ['value', 'text', 'description', 'section'],

        // Callback
        onChange: null

      }

      // make sortable if jQuery UI present
      if (jQuery.ui) {
        args_multiselect.sortable = true;
      }

      $("#selectCity").treeMultiselect(args_multiselect);

    } // end paikkakunnat_input exist

    // move description to bottom for join forms
    $('#gform_wrapper_3 .gform_description').detach().appendTo($('#gform_wrapper_3 .gform_body'));
    $('#gform_wrapper_5 .gform_description').detach().appendTo($('#gform_wrapper_5 .gform_body'));

    // init jasenmaksulaskuri
    $('#jasenmaksulaskuri').isannointi_jasenmaksulaskuri();


  });

  /**
   * Generic shadow-textarea
   *
   * UI: <div class="js-shadow-checkbox" data-shadow="input_2_20">
   *       <input type="checkbox" value="Lorem">
   *       <input type="checkbox" value="Ipsum">
   *     </div>
   * Shadow: <input id="input_2_20" value="Lorem||Ipsum">
   *
   */
  jQuery(document).on('gform_post_render', function(){

    $('.js-shadow-checkbox').each(function(index) {

      var $checkbox = $(this);
      var shadow_id = $checkbox.attr('data-shadow');
      var $shadow   = $('#' + shadow_id);

      // copy value from shadow to UI
      var saved_values = $shadow.val();
      if (saved_values) {
        var saved_values_arr = saved_values.split('||');
        $.each(saved_values_arr, function(key, value) {
          $checkbox.find('input').each(function(index) {
            if ($(this).val() == value) {
              $(this).prop("checked", true);
            }
          });
        });
        //console.log(saved_values_arr);
        //$checkbox.children
      }


      $checkbox.find('input').each(function(index) {
        $(this).on('change', function() {

          // form new string from checkbox values
          var values = [];
          $checkbox.find('input').each(function(i) {
            if ($(this).prop('checked')) {
              values.push($(this).val());
            }
          });

          var values_str = '';
          if (values.length) {
            values_str = values.join('||');
          }

          $shadow.val(values_str);

        });
      });


      // from there on copy value from UI
      //$checkbox.on('change keyup paste', function() {
      //  $shadow.val($textarea.val());
      //});

    });
  });

  /**
   * Generic shadow-textarea
   *
   * UI: <textarea class="js-shadow-textarea" data-shadow="input_2_20">
   * Shadow: <input id="input_2_20">
   *
   */
  jQuery(document).on('gform_post_render', function(){

    $('.js-shadow-textarea').each(function( index ) {
      var $textarea = $(this);
      var shadow_id = $textarea.attr('data-shadow');
      var $shadow = $('#' + shadow_id);

      // copy value from shadow to UI
      $textarea.val($shadow.val());

      // from there on copy value from UI
      $textarea.on('change keyup paste', function() {
        $shadow.val($textarea.val());
      });

    });
  });

  // Add warning when textarea max character count near
  jQuery(document).on('gform_post_render', function(){

    $('.js-shadow-textarea').each(function() {

      var thisTextarea = $(this);
      var warningSpan = thisTextarea.next().next('.js-character-count-warning');

      thisTextarea.on('input', function () {
        if( thisTextarea.val().length  > ( thisTextarea.attr('maxlength') - 20) ) {
          warningSpan.html('Huom! Yli menevät merkit poistuvat automaattisesti!');

        } else {
          warningSpan.html('');

        }
      });

    });
  });

  // Terms and conditions
  $('#open-terms-and-conditions').click(function(e) {
    e.preventDefault();
    $('#terms-and-conditions').addClass('active');
  });
  $('#close-terms-and-conditions').click(function() {
    $('#terms-and-conditions').removeClass('active');
  });


})(jQuery);
